import { initAddress } from '../../components/address'

function initApplicantCreate() {
  initAddress()
}

export { initApplicantCreate }
